

















import { getSelectedBusinessUnitFromLocal } from '@/services/session-data';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import BaseComponent from '../base-component.vue';

@Component({
  components: {},
})
export default class WhatsappButton extends BaseComponent {
  
  @Prop({ default: true })
  private fixed: boolean;

  @Prop({ default: ''})
  private classCss: string;

  // Hardcoded temporario, somente para teste do uso Whatsapp conforme solicitado no card;
  private url: string = 'https://api.whatsapp.com/send/?phone=';
  private telNutriente: string = '552130352800';
  private telFarmoterapica: string= '551150863044';
  private telUsar:string;

  private disponivel: boolean = false;

  private mounted() {
    // Hardcoded temporario, somente para teste do uso Whatsapp conforme solicitado no card;
    this.disponivel = false;
    getSelectedBusinessUnitFromLocal().subscribe((bu) => {
      this.disponivel = true;
      this.telUsar = bu && bu.id == 3 ? this.telNutriente : this.telFarmoterapica;
    });
  }

  private open(): void {
    window.open(this.url + this.telUsar, '_blank');
  }

}
